import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export abstract class FatalDecoratorError extends FatalError {
  constructor(decorator: string, key: PropertyKey) {
    super(`@${decorator}`, String(key))
  }
}

export class FatalDecoratorExistedError extends FatalDecoratorError {
  static override locales: Locales = {
    'en-US': '%s decoration %s failed, descriptor already exists',
    'zh-CN': '%s 装饰 %s 失败，描述符已存在',
    'zh-HK': '%s 裝飾 %s 失敗，描述符已存在'
  }

  override name = 'FatalDecoratorExistedError' as const
}

export class FatalDecoratorLimitClassError extends FatalError {
  static override locales: Locales = {
    'en-US':
      '%s decoration failed, only supports decoration specified %s class',
    'zh-CN': '%s 装饰失败，仅支持装饰指定 %s 类',
    'zh-HK': '%s 裝飾失敗，僅支持裝飾指定 %s 類'
  }

  override name = 'FatalDecoratorLimitClassError' as const

  constructor(decorator: string, className: string) {
    super(`@${decorator}`, className)
  }
}

export class FatalDecoratorLimitDescriptorError extends FatalError {
  static override locales: Locales = {
    'en-US':
      '%s decoration %s failed, only supports specified %s class descriptor',
    'zh-CN': '%s 装饰 %s 失败，仅支持装饰指定 %s 类描述符',
    'zh-HK': '%s 裝飾 %s 失敗，僅支持裝飾指定 %s 類描述符'
  }

  override name = 'FatalDecoratorLimitDescriptorError' as const

  constructor(decorator: string, key: PropertyKey, className: string) {
    super(`@${decorator}`, String(key), className)
  }
}

export class FatalDecoratorLimitGetterError extends FatalDecoratorError {
  static override locales: Locales = {
    'en-US': '%s decoration %s failed, only supports getter descriptors',
    'zh-CN': '%s 装饰 %s 失败，仅支持装饰 getter 描述符',
    'zh-HK': '%s 裝飾 %s 失敗，僅支持裝飾 getter 描述符'
  }

  override name = 'FatalDecoratorLimitGetterError' as const
}

export class FatalDecoratorLimitMethodError extends FatalDecoratorError {
  static override locales: Locales = {
    'en-US': '%s decoration %s failed, only supports method descriptors',
    'zh-CN': '%s 装饰 %s 失败，仅支持装饰方法描述符',
    'zh-HK': '%s 裝飾 %s 失敗，僅支持裝飾方法描述符'
  }

  override name = 'FatalDecoratorLimitMethodError' as const
}

export class FatalDecoratorLimitSetterError extends FatalDecoratorError {
  static override locales: Locales = {
    'en-US': '%s decoration %s failed, only supports setter descriptors',
    'zh-CN': '%s 装饰 %s 失败，仅支持装饰 setter 描述符',
    'zh-HK': '%s 裝飾 %s 失敗，僅支持裝飾 setter 描述符'
  }

  override name = 'FatalDecoratorLimitSetterError' as const
}

export class FatalDecoratorNotSupportError extends FatalDecoratorError {
  static override locales: Locales = {
    'en-US': '%s decoration %s failed, unsupported decorator type',
    'zh-CN': '%s 装饰 %s 失败，不支持的装饰器类型',
    'zh-HK': '%s 裝飾 %s 失敗，不支持的裝飾器類型'
  }

  override name = 'FatalDecoratorNotSupportError' as const
}
